import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { compose } from 'ramda';
import { withHandlers } from 'recompose';

import Button from 'app/components/Button/Button';
import { LOGIN_URL } from 'app/router/constants/externalUrls';
import connect from 'app/libs/connect';
import { registrationSelected } from 'app/features/authentication/actions/register';

const UI = ({ onClick }) => (
  <Button
    to={LOGIN_URL}
    textKey="buttons_create_my_account"
    type="oneWeak"
    testId="product-comparison-subscription-cta"
    isWide
    onClick={onClick}
  >
    <FormattedMessage id="buttons_create_my_account" />
  </Button>
);

UI.propTypes = { onClick: PropTypes.func.isRequired };

UI.displayName = 'CreateAccountButton';

const onClick =
  ({ registrationSelected }) =>
  () => {
    registrationSelected();
  };

const CreateAccountButton = compose(
  connect(null, { registrationSelected }),
  withHandlers({ onClick }),
)(UI);

export { UI, onClick };

export default CreateAccountButton;
